// removed by extract-text-webpack-plugin
module.exports = {"cover":"bzTxDXWxt3nLUoglTFmwN","media":"_103BmLwQgqPYbeQeYA1BmI","visible":"_2WgAQryCbU2NX4hmbty6_s","VideoAppear":"jtpJRZcBiy9Y1HEvqv4T4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/Media.module.scss
// module id = 789
// module chunks = 0